import StudentList from '../../features/admin/StudentList'

const StudentListPage = () => {
  return <StudentList />
}

export default StudentListPage